export const getDecorators = (decorators) =>
   Object.fromEntries(
      (decorators ?? []).map((decorator) => [decorator.name, decorator.properties]),
   );
